"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var web3utils = __importStar(require("web3-utils"));

var isNumber_1 = __importDefault(require("./isNumber"));

var toBN_1 = __importDefault(require("./toBN"));

var fromWei = function fromWei(amount, unit) {
  if (unit === void 0) {
    unit = 'ether';
  }

  if (isNumber_1.default(unit) && Number(unit) <= 18) {
    return toBN_1.default(amount).div(Math.pow(10, unit)).toString();
  }

  return web3utils.fromWei(amount, unit);
};

exports.default = fromWei;